import { api } from 'utility';
import { getIncomeBasedOnProductUrl } from 'URLs';
export function getIncome(data, params) {
  return api.post(getIncomeBasedOnProductUrl(), data, { params }).then((res) => res.data);
}

export default {
  getIncome,
};
